export default __webpack_public_path__ + "static/media/react.a544fd8c.png";